import React from 'react';
import styled from 'styled-components';
import Card from '../../../../components/Card';
import { I18n } from 'react-redux-i18n';

const DirectPmmContainer = styled.div`
  width: 100%;

  .directPmmContainer {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 20px;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    justify-content: space-between;
  }

  .directPmmValue {
    margin-bottom: 12px;
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    color: #1f2b37;
  }

  .pmmValueContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 200px;

    border-radius: 2px;
    border: solid 1px #e8eaeb;
  }

  .pmmValue {
    margin-left: 10px;
    font-size: 12px;
  }

  .pmmCurrencyCode {
    min-width: 45px;
    min-height: 45px;
    border-radius: 2px;
    font-size: 14px;
    border: solid 1px #e8eaeb;
    background-color: rgba(232, 234, 235, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const DirectPmm = ({ data }) => (
  <DirectPmmContainer>
    <Card>
      <div className="directPmmContainer">
        {data.map((pmm, index) => (
          <div key={index}>
            <p className="directPmmValue">{`${I18n.t('primeur.direct.pmm')} ${
              pmm.currency_name
            }`}</p>
            <div className="pmmValueContainer">
              <div className="pmmCurrencyCode">
                {Number(null)
                  .toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: pmm.currency_code,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  })
                  .replace('0', '')}
              </div>
              <p className="pmmValue">
                {pmm.value.toLocaleString('fr-FR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  </DirectPmmContainer>
);

export default DirectPmm;
